var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9999 6.33415C3.91222 6.33417 3.8254 6.3169 3.74441 6.28333C3.66342 6.24975 3.58985 6.20053 3.52791 6.13848L0.194652 2.80515C0.0697375 2.67983 -0.000280455 2.51003 8.44329e-07 2.33309C0.000282144 2.15615 0.0708397 1.98657 0.196152 1.86165C0.321463 1.73673 0.491265 1.66671 0.668201 1.66699C0.845138 1.66727 1.01472 1.73783 1.13963 1.86315L3.9999 4.72315L6.85983 1.86315C6.98505 1.73788 7.15491 1.66748 7.33204 1.66745C7.50916 1.66742 7.67904 1.73776 7.80431 1.86298C7.92958 1.98821 7.99997 2.15807 8 2.3352C8.00003 2.51233 7.9297 2.68221 7.80448 2.80748L4.47122 6.14082C4.3459 6.26512 4.1764 6.33464 3.9999 6.33415Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackChevron);
export default __webpack_public_path__ + "static/media/blackChevron.7b7140508deda703c6b63ddbd6b0b29b.svg";
export { ForwardRef as ReactComponent };